/* "Blue" by tPenguinLTG
 * https://www.deviantart.com/tpenguinltg/art/Blue-525167751
 */

export default {
  name: 'blue',
  anchor: 'rgb(0, 0, 128)',
  anchorVisited: 'rgb(0, 0, 128)',
  borderDark: 'rgb(49, 131, 221)',
  borderDarkest: 'rgb(0, 0, 0)',
  borderLight: 'rgb(166, 202, 240)',
  borderLightest: 'rgb(211, 228, 248)',
  canvas: 'rgb(255, 255, 255)',
  canvasText: 'rgb(0, 0, 0)',
  canvasTextDisabled: 'rgb(49, 131, 221)',
  canvasTextDisabledShadow: 'rgb(211, 228, 248)',
  canvasTextInvert: 'rgb(255, 255, 255)',
  checkmark: 'rgb(0, 0, 0)',
  checkmarkDisabled: 'rgb(49, 131, 221)',
  flatDark: 'rgb(49, 131, 221)',
  flatLight: 'rgb(166, 202, 240)',
  focusSecondary: 'rgb(211, 228, 248)',
  headerBackground: 'rgb(0, 0, 128)',
  headerNotActiveBackground: 'rgb(49, 131, 221)',
  headerNotActiveText: 'rgb(0, 0, 128)',
  headerText: 'rgb(255, 255, 255)',
  hoverBackground: 'rgb(51, 153, 255)',
  material: 'rgb(166, 202, 240)',
  materialDark: 'rgb(49, 131, 221)',
  materialText: 'rgb(0, 0, 0)',
  materialTextDisabled: 'rgb(49, 131, 221)',
  materialTextDisabledShadow: 'rgb(211, 228, 248)',
  materialTextInvert: 'rgb(255, 255, 255)',
  progress: 'rgb(51, 153, 255)',
  tooltip: 'rgb(225, 225, 255)',
};
